import React from "react";
import { connect } from "react-redux";
import throttle from "lodash/throttle";

import Carousel from "../../../components/Carousel";
import tracking from "../../../utils/tracking";
import {
  HEADER_COPY,
  BODY_COPY,
  CTA_COPY,
  IMAGE
} from "../../../utils/content-keys";
import "./private-functions.scss";
import { activateOverlayAction } from "../../../services/ui/overlay/actions";

import lazyLoad from "../../../utils/lazy-load";

class PrivateFunctions extends React.Component {
  carouselRef = null;
  throttledScroll = null;

  componentDidMount() {
    if (window.location.hash === "#bookingForm" && !this.props.triggered) {
      this.props.activateOverlayAction(this.props.overlayId);
    }

    this.throttledScroll = throttle(
      () =>
        lazyLoad(
          this.carouselRef,
          window.innerHeight + 150,
          this.scrollCallback
        ),
      200
    );

    window.addEventListener("scroll", this.throttledScroll);
  }

  scrollCallback = () => {
    if (this.state.visible) {
      return;
    }

    const imgs = Array.prototype.slice.call(
      this.carouselRef.querySelectorAll(".PrivateFunctions__carousel-image")
    );
    imgs.forEach((img) => {img.src = img.getAttribute("data-src");img.src = img.getAttribute("data-src")});
    window.removeEventListener("scroll", this.throttledScroll);
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.throttledScroll);
  }

  render() {
    const {
      overlayId,
      activateOverlayAction,
      content,
      imageCarousel
    } = this.props;

    return (
			<div className="PrivateFunctionsContainer">
      <div className="PrivateFunctions no-gutters row">
        <div
          className=" col-12 col-md-6 PrivateFunctions__col-2"
          ref={el => {
            if (!this.carouselRef && el) {
              this.carouselRef = el;
            }
          }}
        >
					
          <Carousel
            desktopEnabled={true}
            arrows={true}
            key="private-functions-carousel"
            slidesToShow={1}
          >
            {imageCarousel.map((item, index) => (
              <div
                className="PrivateFunctions__item"
                key={`private-function-carousel_${index}`}
              >
                <img
                  data-src={item[IMAGE][0].imgURL}
                  alt={item[IMAGE].value}
                  data-srcset={`${item[IMAGE][1].imgURL} 750w, ${
                    item[IMAGE][0].imgURL
                  } 1984w`}
                  className="PrivateFunctions__carousel-image"
                />
              </div>
            ))}
          </Carousel>
        </div>
				<div className="col-12 col-md-6 PrivateFunctions__col-1">
          <h3 className="PrivateFunctions__title">
            {content[HEADER_COPY].value}
          </h3>
          <div className="PrivateFunctions__content-wrapper">
            <p className="PrivateFunctions__copy">{content[BODY_COPY].value}</p>
            <p
              className="cta PrivateFunctions__cta"
              onClick={() => {
                tracking.event("customEvent", {
                  eventCategory: "Private Functions",
                  eventAction: "click",
                  eventLabel: "Visit the Taproom"
                });

                tracking.pageView("/contact");
                tracking.event("formShown", { formName: "contact" });
                activateOverlayAction(overlayId);
              }}
            >
              {content[CTA_COPY].value}
            </p>
          </div>
        </div>
      </div>
			</div>
    );
  }
}

export default connect(
  state => ({ triggered: state.overlay.triggered }),
  { activateOverlayAction }
)(PrivateFunctions);



// WEBPACK FOOTER //
// ./src/pages/visitus/PrivateFunctions/index.js